/** Canonical public site origin (marketing + default metadata). */
export const SITE_URL = "https://www.getverify.cl" as const;

/** Google Calendar appointment-schedule link for "Agendar una demo" CTAs. */
export const SCHEDULE_DEMO_URL =
  "https://calendar.app.google/RMEirKruokJPPpLA8" as const;
